
import { Component, Vue, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@/components/scope/file-upload.vue";
import { emptyToLine, isoDateFormat } from "@common/src/utils/common";
import AuditDialog from "./components/audit-dialog.vue";
import t from "@common/src/i18n/t";

const common_warranty = namespace("common_warranty");

@Component({
  components: { FileUpload, AuditDialog }
})
export default class ClaimsDetail extends Vue {
  @common_warranty.Action queryWarrantyClaimsDetail;

  @Ref("AuditDialog") AuditDialog;

  emptyToLine = emptyToLine;
  isoDateFormat = isoDateFormat;

  get breadData() {
    return [
      { name: t("v3_7_6.warranty-claims"), path: "/warranty/warranty-claims" },
      { name: t("v3_7_6.claims-details") }
    ];
  }
  handleShowAuditDialog() {
    this.AuditDialog.open(this.applyNo);
  }
  get applyNo() {
    return this.$route.params.id;
  }
  detailData: any = null;
  created() {
    this.init();
  }
  init() {
    this.queryWarrantyClaimsDetail({
      applyNo: this.applyNo
    }).then(({ data }) => {
      data.claimImageList = Object.values(data.claimImage).map(url => ({
        url
      }));
      data.purchaseReceiptUrlList = data.warrantyCard.purchaseReceiptList.map(url => ({
        url
      }));
      this.detailData = data;
    });
  }
}
